import { api } from "./authService";

const reportService = {
  getMySemesters: async () => {
    try {
      const response = await api.get("/me/reports/semester-options");
      return response.data;
    } catch (error) {
      console.error("Error fetching learner semesters:", error);
      throw error;
    }
  },

  getMyReports: async () => {
    try {
      const response = await api.get("/me/reports");
      return response.data;
    } catch (error) {
      console.error("Error fetching my reports:", error);
      throw error;
    }
  },

  uploadReport: async (file, semesterId) => {
    try {
      const formData = new FormData();
      formData.append("file", file);
      if (semesterId) {
        formData.append("semesterId", semesterId);
      }
      const response = await api.post("/me/reports", formData);
      return response.data;
    } catch (error) {
      console.error("Error uploading report:", error);
      throw error;
    }
  },

  downloadMyReport: async (id, filename) => {
    try {
      const response = await api.get(`/me/reports/${id}/download`, {
        responseType: "blob",
      });
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      console.error("Error downloading report:", error);
      throw error;
    }
  },

  // Helper to fetch blob and return object URL for preview
  getPreviewUrl: async (id, learnerId, isOwnProfile) => {
    try {
        const url = isOwnProfile 
            ? `/me/reports/${id}/download`
            : `/learners/${learnerId}/reports/${id}/download`;
            
        const response = await api.get(url, {
            responseType: "blob"
        });
        
        return window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
    } catch (error) {
        console.error("Error fetching preview:", error);
        throw error;
    }
  },

  // Learners archive instead of deleting - the document stays available to staff
  // and to the Revisor review. Permanent deletion is an admin-only action.
  archiveReport: async (id) => {
    const response = await api.post(`/me/reports/${id}/archive`);
    return response.data;
  },

  restoreReport: async (id) => {
    const response = await api.post(`/me/reports/${id}/restore`);
    return response.data;
  },


  getLearnerReports: async (learnerId) => {
    try {
      const response = await api.get(`/learners/${learnerId}/reports`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching reports for learner ${learnerId}:`, error);
      throw error;
    }
  },
  
  downloadLearnerReport: async (learnerId, reportId, filename) => {
    try {
      const response = await api.get(`/learners/${learnerId}/reports/${reportId}/download`, {
        responseType: "blob",
      });
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      console.error("Error downloading learner report:", error);
      throw error;
    }
  },

  // Downloads the selected (or, with no reportIds, every active) report as a single ZIP.
  // Kept generation server-side so permissions stay centralized and the browser only
  // performs one download.
  exportReportsAsZip: async (learnerId, isOwnProfile, reportIds) => {
    try {
      const url = isOwnProfile
        ? "/me/reports/export-zip"
        : `/learners/${learnerId}/reports/export-zip`;
      const response = await api.get(url, {
        responseType: "blob",
        params: reportIds && reportIds.length ? { reportIds } : undefined,
        paramsSerializer: {
          indexes: null,
        },
      });

      const disposition = response.headers["content-disposition"] || "";
      const match = disposition.match(/filename="?([^"]+)"?/);
      const filename = match ? match[1] : "reports.zip";

      const blobUrl = window.URL.createObjectURL(
        new Blob([response.data], { type: "application/zip" }),
      );
      const link = document.createElement("a");
      link.href = blobUrl;
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error("Error exporting reports as zip:", error);
      throw error;
    }
  },
};

export default reportService;
